import React, { useEffect } from 'react';
import Header from "../components/developer_header.jsx";
import Footer from "../components/developer_footer.jsx";
import UserNetsQrFlow from "../../assets/diagrams/user_nets_qr_flow.png";
import UserNetsClickFlow from "../../assets/diagrams/user_nets_click_flow.png";
import UserEnetsDebitFlow from "../../assets/diagrams/user_enets_debit_flow.png";

const CompetitionLayout = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleButtonHover = (e, isHover) => {
    if (isHover) {
      e.target.classList.add('bg-blue-800', 'text-white', 'shadow-lg');
      e.target.classList.remove('bg-blue-600', 'bg-white', 'text-blue-600');
      e.target.style.transform = 'translateY(-2px)';
    } else {
      e.target.classList.remove('bg-blue-800', 'text-white', 'shadow-lg');
      if (e.target.classList.contains('route-button')) {
        e.target.classList.add('bg-blue-600', 'text-white');
      } else {
        e.target.classList.add('bg-white', 'text-gray-800');
      }
      e.target.style.transform = 'translateY(0)';
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col font-sans text-gray-800">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="text-center py-20 text-gray-800">
          <div className="container mx-auto px-4 sm:px-6">
            <h1 className={`font-extrabold mb-5 text-gray-700 ${
              isMobile ? 'text-3xl' : 'text-5xl'
            }`}>
              Competition
            </h1>
            <p className="text-xl mb-10 text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Welcome! Choose your learning journey and develop <br />Financial Technology (FinTech) skills through PolyFinTech100 API Hackathon.
            </p>
            <h2 className={`font-extrabold mb-5 text-gray-700 ${
              isMobile ? 'text-3xl' : 'text-5xl'
            } mt-16`}>
              PolyFinTech100 API Hackathon PayTech Category
            </h2>
          </div>
        </section>

        {/* API Workflows Section */}
        <section className="py-16" style={{ backgroundColor: '#F2F2F2' }}>
          <div className="container mx-auto px-4 sm:px-6 space-y-16">
            
            {/* NETS QR Section */}
            <div className="flex justify-between items-center gap-8 flex-wrap">
              {/* Diagram */}
              <div className="flex-1">
                <img 
                  src={UserNetsQrFlow}
                  alt="NETS QR Payment Process Diagram" 
                  className="w-full h-auto"
                />
              </div>

              {/* Info Card - Added hover animations */}
              <div className="route-card bg-white bg-opacity-95 rounded-2xl p-8 shadow-xl transition-all duration-300 relative overflow-hidden flex flex-col w-[380px] border-2 border-gray-100 hover:shadow-2xl hover:-translate-y-3 hover:border-gray-200">
                {/* Top Border */}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-gray-700 to-gray-600 rounded-t-2xl"></div>
                
                <div>
                  <div className="flex items-center justify-center mb-6">
                    <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mr-4 text-2xl">🧪</div>
                    <h3 className="font-bold text-2xl text-black">NETS QR</h3>
                  </div>
                  <p className="text-base text-gray-600 mb-6">
                    Integrate and ideate NETS QR APIs today
                  </p>
                </div>
                <a
                  href="/competition/nets-qr"
                  className="route-button w-full bg-blue-600 text-white py-6 px-10 rounded-2xl text-3xl font-extrabold hover:bg-blue-700 transition-all duration-300 mt-auto"
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                >
                  Ideate Now
                </a>
              </div>
            </div>

            {/* eNETS Section */}
            <div className="flex justify-between items-center gap-8 flex-wrap">
              <div className="flex-1">
                <img 
                  src={UserEnetsDebitFlow}
                  alt="eNETS Payment Process Diagram" 
                  className="w-full h-auto"
                />
              </div>
              
              {/* Info Card - Added hover animations */}
              <div className="route-card bg-white bg-opacity-95 rounded-2xl p-8 shadow-xl transition-all duration-300 relative overflow-hidden flex flex-col w-[380px] border-2 border-gray-100 hover:shadow-2xl hover:-translate-y-3 hover:border-gray-200">
                {/* Top Border */}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-gray-700 to-gray-600 rounded-t-2xl"></div>
                
                <div>
                  <div className="flex items-center justify-center mb-6">
                    <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mr-4 text-2xl">🎯</div>
                    <h3 className="font-bold text-2xl text-black">eNETS</h3>
                  </div>
                  <p className="text-base text-gray-600 mb-6">
                    Integrate and ideate eNETS APIs today
                  </p>
                </div>
                <a
                  href="/competition/enets"
                  className="route-button w-full bg-blue-600 text-white py-6 px-10 rounded-2xl text-3xl font-extrabold hover:bg-blue-700 transition-all duration-300 mt-auto"
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                >
                  Ideate Now
                </a>
              </div>
            </div>

            {/* NETS Click Section */}
            <div className="flex justify-between items-center gap-8 flex-wrap">
              <div className="flex-1">
                <img 
                  src={UserNetsClickFlow}
                  alt="NETS Click Payment Process Diagram" 
                  className="w-full h-auto"
                />
              </div>
              
              {/* Info Card - Added hover animations */}
              <div className="route-card bg-white bg-opacity-95 rounded-2xl p-8 shadow-xl transition-all duration-300 relative overflow-hidden flex flex-col w-[380px] border-2 border-gray-100 hover:shadow-2xl hover:-translate-y-3 hover:border-gray-200">
                {/* Top Border */}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-gray-700 to-gray-600 rounded-t-2xl"></div>
                
                <div>
                  <div className="flex items-center justify-center mb-6">
                    <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mr-4 text-2xl">🚀</div>
                    <h3 className="font-bold text-2xl text-black">NETS Click</h3>
                  </div>
                  <p className="text-base text-gray-600 mb-6">
                    Integrate and ideate NETS Click APIs today
                  </p>
                </div>
                <a
                  href="/competition/nets-click"
                  className="route-button w-full bg-blue-600 text-white py-6 px-10 rounded-2xl text-3xl font-extrabold hover:bg-blue-700 transition-all duration-300 mt-auto"
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                >
                  Ideate Now
                </a>
              </div>
            </div>

          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default CompetitionLayout;